import { useSuspenseQuery } from "@apollo/client/react";

import {
  GetCategoriesDocument,
  type GetCategoriesQuery,
  type GetCategoriesQueryVariables,
} from "~/features/admin/categories/gqls";

/**
 * Read-only list of categories for the current tenant.
 *
 * Tenant scoping is enforced server-side via the Hasura session — the query
 * no longer takes a tenantId variable (see PR #6550). Reuses the V1 typed
 * document during the read-only phase.
 */
export function useCategoryList() {
  return useSuspenseQuery<GetCategoriesQuery, GetCategoriesQueryVariables>(GetCategoriesDocument);
}
